import { render, staticRenderFns } from "./PasswordRecovery.vue?vue&type=template&id=74afeb7c&"
import script from "@/views/PasswordRecovery/PasswordRecovery.js?vue&type=script&lang=js&"
export * from "@/views/PasswordRecovery/PasswordRecovery.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports